// extracted by mini-css-extract-plugin
export default {"kpi-cards-container":"SavedTimeCards_kpi-cards-container__3qjSk"};